import React, { Component } from "react";
import ProgressItem from "./ProgressItem";
import classNames from "classnames";

export default class Progress extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showProgressDiff: false
    };
  }

  componentDidMount = () => {
    if (this.props.answer !== undefined) {
      setTimeout(() => {
        this.setState({
          showProgressDiff: true
        });
      }, 0);
    }
  };

  render() {
    const { dictionary, data, answer, type } = this.props;
    const { showProgressDiff } = this.state;

    return (
      <div
        className={classNames("progress", {
          "is-vertical": type === "vertical"
        })}
      >
        {data &&
          Object.keys(data).map((key, index) => {
            return (
              <ProgressItem
                key={key}
                label={dictionary[`progress_${key}`]}
                name={key}
                val={data[key]}
                diff={answer !== undefined && answer[key]}
                animateDiff={showProgressDiff}
              />
            );
          })}
      </div>
    );
  }
}
